export function getMonthAbbreviation(month: number): string {
    const monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    if (month < 1 || month > 12) {
        throw new Error('Invalid month number')
    }

    return monthAbbreviations[month - 1]
}
